var time = {};
export {
  time as __exports
};
//# sourceMappingURL=time.js.map
